<div
  class="sidePanelFolder"
  (click)="toggleFolder()"
  role="button"
  aria-label="Toggle folder"
>
  <div class="sidePanelFolder__inner">
    <pp-icon
      [ppSVG]="
        collapsed
          ? iconMap[EIconPath.SIDE_PANEL_SITE_LIST_FOLDER_CLOSED]
          : iconMap[EIconPath.SIDE_PANEL_SITE_LIST_FOLDER_OPENED]
      "
      ppColor="inherit"
      ppClass="setSize16"
    />

    @if (!editing) {
      <span
        class="sidePanelFolder__text"
        ppTooltip
        [ppTrimTooltip]="true"
        [ppTitle]="ppFolder.name"
      >
        {{ ppFolder.name }}
      </span>
    }

    @if (editing) {
      <span class="sidePanelFolder__inputWrapper">
        <input
          type="text"
          [(ngModel)]="ppFolder.name"
          class="sidePanelFolder__input"
          (change)="updateFolder()"
          aria-label="Folder name"
          autofocus
        />
        <pp-icon
          [ppSVG]="iconMap[EIconPath.ICON_MISC_CLOSE_14]"
          ppColor="inherit"
          ppClass="setSize14"
          (click)="cancelEditing()"
          aria-label="Cancel editing"
        />
      </span>
    }
  </div>

  @if (showFolderOptions) {
    <button
      class="folderOptionsButton"
      (click)="toggleFolderSettings($event)"
      [id]="optionsButtonId"
      ppTooltip
      [ppTitle]="'folder_settings' | ppTranslate"
      aria-label="Folder settings"
    >
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_NAV_THREE_DOTS_VERTICAL_18]"
        ppColor="inherit"
        ppClass="setSize18"
      />
    </button>
  }
</div>
